// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1PI1A","delete":"styles_delete__2fODx","update":"styles_update__OELJ8","add":"styles_add__vkh4T"};